import axios from "axios";
const API_BASE_URL = "http://localhost:5001/api"; // Update with your actual API URL

export const getAllStats = async (distributor) => {
  try {
    // const response = await axios.get(`${API_BASE_URL}/sales/products`);
    // return response.data;
    // console.log("distributor", distributor);
    if (distributor.trim() === "distributor 1") {
      const response = {
        success: true,
        message: "Sales products fetched successfully",
        data: {
          totalLeads: {
            daily: 10,
            weekly: 50,
            monthly: 20,
            yearly: 60,
          },
          totalSales: {
            daily: 40,
            weekly: 40,
            monthly: 70,
            yearly: 90,
          },
          totalRevenue: {
            daily: 1000,
            weekly: 12000,
            monthly: 60000,
            yearly: 75000,
          },
        },
        error: null,
      };
      return response.data;
    } else {
      const response = {
        success: true,
        message: "Sales products fetched successfully",
        data: {
          totalLeads: {
            daily: 20,
            weekly: 50,
            monthly: 20,
            yearly: 60,
          },
          totalSales: {
            daily: 20,
            weekly: 40,
            monthly: 70,
            yearly: 90,
          },
          totalRevenue: {
            daily: 2000,
            weekly: 12000,
            monthly: 60000,
            yearly: 75000,
          },
        },
        error: null,
      };
      return response.data;
    }
  } catch (error) {
    return console.error("Error fetching sales vs product data ");
  }
};
export const getSalesOfProducts = async (distributor) => {
  try {
    // const response = await axios.get(`${API_BASE_URL}/sales/products`);
    // return response.data;
    const response = {
      success: true,
      message: "Sales products fetched successfully",
      data: {
        salesProducts: {
          weekly: [
            {
              _id: "67b447ee2ca5d45ab70be32d",
              name: "Product1 ",
              sales: 8,
            },
            {
              _id: "67b447472ca5d45ab70be32c",
              name: "Product2 ",
              sales: 18,
            },
            {
              _id: "67b447ee2ca5d45ab70be31d",
              name: "Product3 ",
              sales: 38,
            },
            {
              _id: "67b447472ca5d45ab70be30c",
              name: "Product4 ",
              sales: 6,
            },
            {
              _id: "67b447ee2ca5d45ab70be32e",
              name: "Product5 ",
              sales: 18,
            },
            {
              _id: "66b447472ca5d45ab70be32c",
              name: "Product6 ",
              sales: 68,
            },
            {
              _id: "67a447ee2ca5d45ab70be31d",
              name: "Product7 ",
              sales: 8,
            },
            {
              _id: "67b457472ca5d45ab70be30c",
              name: "Product8 ",
              sales: 4,
            },
          ],

          monthly: [
            {
              _id: "67a447ee2ca5d45ab70be31d",
              name: "Product1 ",
              sales: 80,
            },
            {
              _id: "67b457472ca5d45ab70be30c",
              name: "Product2 ",
              sales: 68,
            },
          ],
          yearly: [
            {
              _id: "67a447ee2ca5d45ab70be31d",
              name: "Product3 ",
              sales: 38,
            },
            {
              _id: "67b457472ca5d45ab70be30c",
              name: "Product4 ",
              sales: 48,
            },
            { _id: "67b457472ca5d45al70be30c", name: "Product8", sales: 4 },
            { _id: "67a447ee2ca5b45ab80be31d", name: "Product9", sales: 80 },
            { _id: "67b457472ca5d65ab70be30c", name: "Product10", sales: 68 },
            { _id: "67a447ee2ca5r45ab70be31d", name: "Product13", sales: 38 },
            { _id: "67b457472ca5d49ab70be30c", name: "Product14", sales: 48 },
            { _id: "67b457472ca5d45al70be30c", name: "Product8", sales: 4 },
            { _id: "67a447ee2ca5b45ab80be31d", name: "Product9", sales: 80 },
            { _id: "67b457472ca5d65ab70be30c", name: "Product10", sales: 68 },
            { _id: "67a447ee2ca5r45ab70be31d", name: "Product13", sales: 38 },
            { _id: "67b457472ca5d45al70be30c", name: "Product8", sales: 4 },
            { _id: "67a447ee2ca5b45ab80be31d", name: "Product9", sales: 80 },
            { _id: "67b457472ca5d65ab70be30c", name: "Product10", sales: 68 },
            { _id: "67a447ee2ca5r45ab70be31d", name: "Product13", sales: 38 },
            { _id: "67b457472ca5d65ab70be30c", name: "Product10", sales: 68 },
            { _id: "67a447ee2ca5r45ab70be31d", name: "Product13", sales: 38 },
            { _id: "67b457472ca5d45al70be30c", name: "Product8", sales: 4 },
            { _id: "67a447ee2ca5b45ab80be31d", name: "Product9", sales: 80 },
            { _id: "67b457472ca5d65ab70be30c", name: "Product10", sales: 68 },
            { _id: "67a447ee2ca5r45ab70be31d", name: "Product13", sales: 38 },
            { _id: "67b457472ca5d65ab70be30c", name: "Product10", sales: 68 },
            { _id: "67a447ee2ca5r45ab70be31d", name: "Product13", sales: 38 },
            { _id: "67b457472ca5d45al70be30c", name: "Product8", sales: 4 },
            { _id: "67a447ee2ca5b45ab80be31d", name: "Product9", sales: 80 },
            { _id: "67b457472ca5d65ab70be30c", name: "Product10", sales: 68 },
            { _id: "67a447ee2ca5r45ab70be31d", name: "Product13", sales: 38 },
            { _id: "67a447ee2ca5b45ab80be31d", name: "Product9", sales: 80 },
            { _id: "67b457472ca5d65ab70be30c", name: "Product10", sales: 68 },
            { _id: "67a447ee2ca5r45ab70be31d", name: "Product13", sales: 38 },
            { _id: "67b457472ca5d65ab70be30c", name: "Product10", sales: 68 },
            { _id: "67a447ee2ca5r45ab70be31d", name: "Product13", sales: 38 },
            { _id: "67b457472ca5d45al70be30c", name: "Product8", sales: 4 },
            { _id: "67a447ee2ca5b45ab80be31d", name: "Product9", sales: 80 },
            { _id: "67b457472ca5d65ab70be30c", name: "Product10", sales: 68 },
            { _id: "67a447ee2ca5r45ab70be31d", name: "Product13", sales: 38 },
            { _id: "67b457472ca5d65ab70be30c", name: "Product10", sales: 68 },
            { _id: "67a447ee2ca5r45ab70be31d", name: "Product13", sales: 38 },
            { _id: "67b457472ca5d45al70be30c", name: "Product8", sales: 4 },
            { _id: "67a447ee2ca5b45ab80be31d", name: "Product9", sales: 80 },
            { _id: "67b457472ca5d65ab70be30c", name: "Product10", sales: 68 },
            { _id: "67a447ee2ca5r45ab70be31d", name: "Product13", sales: 38 },
          ],
        },
      },
      error: null,
    };
    if (response.success) {
      return response.data.salesProducts;
    }
  } catch (error) {
    return console.error("Error fetching sales vs product data ");
  }
};
export const getSales = async (distributor) => {
  try {
    // Simulated API response
    const response = {
      success: true,
      message: "Sales products fetched successfully",
      data: {
        salesProducts: [
          { _id: "67b447ee2ca5d45ab70be32d", name: "Product1", sales: 8 },
          { _id: "67b447472ca5d45ab70be32c", name: "Product2", sales: 18 },
          { _id: "67b447ee2ca5d45ab70be31d", name: "Product3", sales: 38 },
          { _id: "67b447472ca5d45ab70be30c", name: "Product4", sales: 6 },
          { _id: "67b447ee2ca5d45ab70be32e", name: "Product5", sales: 18 },
          { _id: "66b447472ca5d45ab70be32c", name: "Product6", sales: 68 },
          { _id: "67a447ee2ca5l45ab70be31d", name: "Product7", sales: 8 },
          { _id: "67b457472ca5d45ab70be30c", name: "Product8", sales: 4 },
          { _id: "67a447ee2ca5d45ab70be31d", name: "Product1", sales: 80 },
          { _id: "67b457472ca5f45ab70be30c", name: "Product2", sales: 68 },
          { _id: "67a447ee2ca5k45ab70be31d", name: "Product23", sales: 38 },
          { _id: "67b457472ca5d45sb70be30c", name: "Product12", sales: 48 },
        ],
      },
      error: null,
    };

    if (response.success) {
      return response.data.salesProducts;
    }
  } catch (error) {
    console.error("Error fetching sales vs product data", error);
    return [];
  }
};
export const getTopSellingProducts = async (distributor) => {
  try {
    // const response = await axios.get(`${API_BASE_URL}/sales/products`);
    // return response.data;
    const response = {
      success: true,
      message: "Sales products fetched successfully",
      data: {
        salesProducts: {
          thisweek: [
            {
              _id: "67b447ee2ca5d45ab70be32d",
              name: "Freestyle OA Med RT L ",
              count: 23,
              total: 38,
            },
            {
              _id: "67b447472ca5d45ab70be32c",
              name: "Contender Boxer ",
              count: 23,
              total: 38,
            },
            {
              _id: "67b447ee2ca5d45ab70be31d",
              name: "Product3 ",
              count: 23,
              total: 38,
            },
            {
              _id: "67b447472ca5d45ab70be30c",
              name: "Product4 ",
              count: 23,
              total: 38,
            },
            {
              _id: "67b447ee2ca5d45ab70be32e",
              name: "Product5 ",
              count: 23,
              total: 38,
            },
            {
              _id: "66b447472ca5d45ab70be32c",
              name: "Product6 ",
              count: 23,
              total: 38,
            },
            {
              _id: "67a447ee2ca5d45ab70be31d",
              name: "Product7 ",
              count: 23,
              total: 38,
            },
            {
              _id: "67b457472ca5d45ab70be30c",
              name: "Product8 ",
              count: 23,
              total: 38,
            },
          ],

          thismonth: [
            {
              _id: "67a447ee2ca5d45ab70be31d",
              name: "Product1 ",
              count: 23,
              total: 98,
            },
            {
              _id: "67b457472ca5d45ab70be30c",
              name: "Product2 ",
              count: 23,
              total: 98,
            },
          ],
          thisyear: [
            {
              _id: "67a447ee2ca5d45ab70be31d",
              name: "Product3 ",
              count: 23,
              total: 38,
            },
            {
              _id: "67b457472ca5d45ab70be30c",
              name: "Product4 ",
              count: 33,
              total: 38,
            },
          ],
        },
      },
      error: null,
    };
    if (response.success) {
      return response.data.salesProducts;
    }
  } catch (error) {
    return console.error("Error fetching sales vs product data ");
  }
};
// Fetch all dashboard data in one function
export const fetchDashboardData = async (distributor) => {
  try {
    const [stats, salesProducts, sales, topSellingProducts] = await Promise.all(
      [
        getAllStats(distributor),
        getSalesOfProducts(distributor),
        getSales(distributor),
        getTopSellingProducts(distributor),
      ]
    );

    return {
      stats,
      salesProducts,
      sales,
      topSellingProducts,
    };
  } catch (error) {
    console.log("Error fetching dashboard data ");
  }
};
